import { z } from 'zod';

export const eventFormSchema = z.object({
  firstName: z.string().min(1, 'Imię jest wymagane'),
  roomNumber: z.string().min(1, 'Numer pokoju jest wymagany'),
});
